import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"



import NavElement from './NavElement.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavItem',
  props: {
  name: String,
  href: String,
  isExpanded: Boolean,
  disabled: Boolean,
  comingSoon: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: !__props.disabled ? __props.href ?? '' : '',
    id: 'nav-row-' + __props.name,
    class: _normalizeClass({ 'disabled-link': __props.disabled })
  }, {
    default: _withCtx(() => [
      _createVNode(NavElement, {
        disabled: __props.disabled,
        "coming-soon": __props.comingSoon,
        name: __props.name,
        href: __props.href,
        "is-expanded": __props.isExpanded
      }, null, 8, ["disabled", "coming-soon", "name", "href", "is-expanded"])
    ]),
    _: 1
  }, 8, ["to", "id", "class"]))
}
}

})